// extracted by mini-css-extract-plugin
export default {"root":"ChangePasswordForm_root__qbBcC","form":"ChangePasswordForm_form__B74FY","after":"ChangePasswordForm_after__441LD"};